
import { Component, Vue } from 'vue-property-decorator';
import { getAddressStatistics, exportAddressStatistics } from '@/api/statisticsAddress';
import { UserModule } from '@/store/modules/user';
import {
  checkPermissionCompany,
  checkPermissionRole,
} from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'StatisticsAddress',
  components: {}
})
export default class extends Vue {
  private formSearch:any = {
    timePeriods: '',
  };
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  };

  private pAddressArr = [{id:0,name:"顶级"}];
  private pAddressLevel = 1;

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private loading = false;
  private tableData: any = [];
  private titleData: any = {};

  private sortField = '';
  private sortRule = '';

  private handleSortChange({ prop, order }: any) {
    if (order) {
      // 订单占比后端为计算字段，排序时使用总订单数
      this.sortField = prop === 'orderRatio' ? 'totalCount' : prop;
      // sort_rule: 1 倒序(desc) 2 正序(asc)
      this.sortRule = order === 'descending' ? '1' : '2';
    } else {
      this.sortField = '';
      this.sortRule = '';
    }
    this.pagination.currentPage = 1;
    this.getList();
  }

  private selectedData: string[] = [];
  private handleSelected(val:any[]) {
    this.selectedData = val;
  }
  
  // 导出Excel
  private handleExport() {
    const pAddressId = this.pAddressArr[this.pAddressArr.length - 1].id;
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      level: this.pAddressLevel,
      p_address_id: pAddressId,
      time_type: 5,
    };
    
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    
    exportAddressStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  created() {
    this.pAddressArr = [{id:0,name:"顶级"}];
    this.pAddressLevel = 1;
    this.initTimePeriods();  
    this.getList();
  }
  
  private initTimePeriods() {
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
  }
  
  private getList() {
    const pAddressId = this.pAddressArr[this.pAddressArr.length - 1].id;
    let orderParams:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      level: this.pAddressLevel,
      p_address_id: pAddressId,
      time_type: 5,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };

    if (this.sortField) {
      orderParams.sort_field = this.sortField;
      orderParams.sort_rule = this.sortRule;
    }

    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = this.formSearch.timePeriods[0] / 1000;
      orderParams.end_time = this.formSearch.timePeriods[1] / 1000;
    }

    this.loading = true;
    getAddressStatistics(orderParams).then(res => {
      if (res && res.data && res.data.list) {

        this.tableData = res.data.list;
        this.titleData = res.data.titleDes;

        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);

      } else {

        this.pagination.total = 0;
        this.titleData = res.data.titleDes;
        this.tableData = [];
        
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
    });
  }

  private handleBack() {
    this.pAddressLevel = this.pAddressLevel - 1;
    this.pAddressArr.pop();
    this.getList();
  }

  private handleBranch(row:any) {
    this.pAddressLevel = this.pAddressLevel + 1;
    this.pAddressArr.push({id: row.addressId, name: row.name});
    this.pagination.currentPage = 1;
    this.getList();
  }
  
  private handleCellClick(row: any, v: string) {
    if(!checkPermissionRole(
        UserModule.getCompanyId,
        Type.ORDER_LOOK_COM
    )){
      return;
    }
    
    if(!['completeCount','closeCount','totalCount'].includes(v)){
      return;
    }
    if(parseInt(row[v]) <= 0){
      return;
    }
    let id = '';
    let order_service_finish_state = '';
    let finish_start_time = 0;
    let finish_end_time = 0;
    let address_id = '';
    let p_address_id = '';
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      finish_start_time = this.formSearch.timePeriods[0] / 1000;
      finish_end_time = this.formSearch.timePeriods[1] / 1000;
    }
    if (this.pAddressLevel === 1) {
      id = row.p_address_id;
    } else {
      id = row.address_id;
    }
    if (this.pAddressLevel === 1) {
      p_address_id = id;
    } else {
      address_id = id;
    }
    
    switch (v) {
      case 'completeCount':
        order_service_finish_state = '1';
        break;
      case 'closeCount':
        order_service_finish_state = '2';
        break;
      case 'totalCount':
        break;
      default:
        break;
    }
    
    const routeData = this.$router.resolve({
      path: '/OrderServicer/completed',
      query: { 
        'p_address_id': p_address_id,
        'address_id': address_id,
        'order_service_finish_state': order_service_finish_state,
        'finish_start_time': finish_start_time + "",
        'finish_end_time': finish_end_time + ""
      }
    });
    window.open(routeData.href, '_blank');
  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleClear() {
    this.formSearch = {
      timePeriods: [],
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
